import InfluencerRequestsScreenConnector from './InfluencerRequestsScreenConnector';

export default InfluencerRequestsScreenConnector;
